import { equals } from 'ramda';
/**
 * Represents an Autofill Corner Component.
 */
class AutofillCornerComponent {
    /**
     * Creates an instance of AutofillCornerComponent.
     * @param leftWallWidth - Width of the left wall.
     * @param rightWallWidth - Width of the right wall.
     * @param leftWallDepth - Depth of the left wall.
     * @param rightWallDepth - Depth of the right wall.
     * @param cameraDirection - Direction of the camera.
     * @param frameHeight - Height of the frame.
     * @param design - Product design.
     * @param finished - Callback function when finished.
     */
    constructor(leftWallWidth, rightWallWidth, leftWallDepth, rightWallDepth, cameraDirection, frameHeight, design, finished) {
        this.typeId = AutofillCornerComponent.id;
        this.doStoreInSnapshot = false;
        this.serializable = false;
        this.leftWallWidth = 0;
        this.rightWallWidth = 0;
        this.leftWallDepth = 0;
        this.rightWallDepth = 0;
        this.frameHeight = 0;
        this.leftWallWidth = leftWallWidth;
        this.rightWallWidth = rightWallWidth;
        this.leftWallDepth = leftWallDepth;
        this.rightWallDepth = rightWallDepth;
        this.cameraDirection = cameraDirection;
        this.frameHeight = frameHeight;
        this.design = design;
        this.finished = finished;
    }
    /**
     * Checks if this component is equal to another AutofillCornerComponent.
     * @param other - Another AutofillCornerComponent to compare with.
     * @returns True if the components are equal, otherwise false.
     */
    eq(other) {
        return (this.leftWallWidth === other.leftWallWidth &&
            this.rightWallWidth === other.rightWallWidth &&
            this.leftWallDepth === other.leftWallDepth &&
            this.rightWallDepth === other.rightWallDepth &&
            equals(this.cameraDirection, other.cameraDirection) &&
            this.frameHeight === other.frameHeight &&
            this.design === other.design);
    }
}
AutofillCornerComponent.id = 2090;
export default AutofillCornerComponent;
//# sourceMappingURL=AutofillCornerComponent.js.map